import React, { useEffect, useState } from 'react';
import Navigation from 'components/Navigation';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { ReactComponent as CheckCircleFilled } from 'assets/icons/checkCircleFilled.svg';

function DiagnosticCard({
  selected,
  type,
  setType,
  image,
  icon,
  title,
  paragraph,
  list,
}) {
  return (
    <div
      className={clsx(
        'flex-1 border border-solid rounded-lg overflow-hidden flex flex-col bg-white cursor-pointer',
        {
          'border-orange-particuliers': selected,
          'border-xborder': !selected,
        },
      )}
      role="button"
      onClick={() => setType(type)}
    >
      {image && (
        <div className="w-full h-[154px] overflow-hidden relative hidden sm:block">
          <img src={image} alt={title} className="w-full h-full object-cover" />
        </div>
      )}

      <div className="p-4">
        {title && (
          <div className="flex items-center gap-2">
            {icon && (
              <img
                src={icon}
                alt={title}
                className="w-[25px] h-[25px] object-cover"
              />
            )}
            <h3 className="text-gris-hellio text-base font-bold leading-6 m-0">
              {title}
            </h3>
          </div>
        )}

        {paragraph && (
          <p
            className="text-[14px] leading-[24px] text-gris-hellio !leading-snug !mt-4"
            dangerouslySetInnerHTML={{ __html: paragraph }}
          />
        )}

        {list && (
          <ul className="flex flex-col gap-1 !mt-2">
            {list.map((item) => (
              <li key={item} className="flex items-center gap-1 p-1 rounded-lg">
                <CheckCircleFilled
                  className="w-4 h-4 shrink-0"
                  aria-hidden="true"
                />
                <span className="text-[14px] leading-[24px] text-gris-hellio">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
DiagnosticCard.propTypes = {
  selected: PropTypes.bool,
  type: PropTypes.string,
  setType: PropTypes.func,
  image: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  paragraph: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
};

export default function QuestionTypeDiagnostic({
  state,
  step,
  nextStep,
  lastStep,
  name,
  dataItems,
  setAnswerAndNext,
}) {
  const previousResponse = state.answers[name] ?? null;
  const items = dataItems[name].items;
  const [type, setType] = useState(previousResponse);

  useEffect(() => {
    setType(previousResponse);
  }, [items, previousResponse]);

  const setTypeAndNext = (value) => {
    setType(value);
    setAnswerAndNext(name, value);
  };

  return (
    <>
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 w-full !mb-6">
        {items.map((item) => (
          <DiagnosticCard
            selected={item.short === type}
            type={item.short}
            setType={setTypeAndNext}
            key={item.short}
            image={item.image}
            icon={item.icon}
            title={item.long}
            paragraph={item.paragraph}
            list={item.list}
          />
        ))}
      </div>

      <Navigation
        data={!!type}
        step={step}
        nextStep={nextStep}
        lastStep={lastStep}
      />
    </>
  );
}

QuestionTypeDiagnostic.propTypes = {
  state: PropTypes.object,
  step: PropTypes.number,
  nextStep: PropTypes.func,
  lastStep: PropTypes.func,
  name: PropTypes.string,
  dataItems: PropTypes.object,
  setAnswerAndNext: PropTypes.func,
};
